// Select the swiper container
const swiperContainer = document.querySelector('.swiper.menu-feature__product');

// Only initialize Swiper if the container exists
if (swiperContainer) {
  const swiper = new Swiper(swiperContainer, {
    direction: 'horizontal',
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        const currentSlides = this.slides.slice(0, this.params.slidesPerView);
        currentSlides.forEach((slide) => {
          const productCards = slide.querySelectorAll('.feature-product__list');
          if (productCards) {
            productCards.forEach((productCard) => {
              productCard.style.opacity = 0;
              anime({
                targets: productCard,
                opacity: [0, 1],
                duration: 500,
                easing: 'easeOutQuad',
              });
            });
          }
        });
      },
      slideChange: function () {
        const currentSlides = this.slides.slice(this.activeIndex, this.activeIndex + this.params.slidesPerView);
        currentSlides.forEach((slide) => {
          const productCards = slide.querySelectorAll('.feature-product__list');
          if (productCards) {
            productCards.forEach((productCard) => {
              productCard.style.opacity = 0;
              anime({
                targets: productCard,
                opacity: [0, 1],
                duration: 500,
                easing: 'easeOutQuad',
              });
            });
          }
        });
      },
    },
  });
}

// ANNIMATION ON CLICK LINK S


// document.addEventListener("DOMContentLoaded", function() {
//   // Check viewport width
//   if (window.innerWidth <= 768) {
//     return;  // If the device is mobile (or narrow viewport), stop the code execution here
//   }

//   const content = document.querySelector('.content-wrapper');

//   // Add fade-out class instantly
//   content.classList.add('fade-out');

//   setTimeout(() => {
//       content.classList.remove('fade-out');
//       content.classList.add('fade-in');
//   }, 200);

//   // For fade-out on link click
//   const links = document.querySelectorAll('a[href]');
//   links.forEach(link => {
//       link.addEventListener('click', function(event) {
          
//           if (link.getAttribute('href') === '#') {
//               return; 
//           }

//           event.preventDefault();
//           content.classList.remove('fade-in');
//           content.classList.add('fade-out');
//           setTimeout(() => {
//               window.location.href = link.getAttribute('href');
//           }, 1000); // Adjusted for a 1.5s transition.
//       });
//   });
// });


// INFINITE SCROLL LOGIC FOR PRODUCT LIST
let isLoading = false;
let nextPage = 2;

// Throttle the scroll event
let throttleTimeout;

window.addEventListener('scroll', function() {
    clearTimeout(throttleTimeout);
    throttleTimeout = setTimeout(() => {
        if (!isLoading && (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 600) {
            isLoading = true;
            loadMoreProducts();
        }
    }, 100);
});

function loadMoreProducts() {
    const collectionName = window.location.pathname.split('/')[2];
    const collectionURL = `/collections/${collectionName}`;
    const nextPageURL = `${collectionURL}?page=${nextPage}`;
    const loadingIndicator = document.querySelector('.loading-indicator');
   
    if (loadingIndicator) {
      loadingIndicator.style.display = 'block';
    }

    fetch(nextPageURL)
        .then(response => {
            if(!response.ok) {
                throw new Error("Network response error");
            }
            return response.text();
        })
        .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            const products = doc.querySelectorAll('.product-grid .grid__item');
            const container = document.querySelector('#product-grid');

            if (products.length === 0) {
                isLoading = true; 
                if (loadingIndicator) {
                    loadingIndicator.style.display = 'none';
                }
                return;
            }

            function addProductSequentially(index) {
                if (index >= products.length) {
                    isLoading = false;
                    if (loadingIndicator) {
                      loadingIndicator.style.display = 'none';
                  }
                    return;
                }

                const product = products[index];
                const productID = product.getAttribute('data-product-id');  

                if (!document.querySelector(`[data-product-id="${productID}"]`)) {
                    product.classList.add('entering');
                    container.appendChild(product);
                    setTimeout(() => {
                        product.classList.remove('entering');
                        addProductSequentially(index + 1); 
                    }, 200); 
                } else {
                    addProductSequentially(index + 1);
                }
            }

            if (products.length) {
                addProductSequentially(0);
            }

            nextPage++;
        })
        .catch(error => {
            console.error('Error fetching more products:', error);
            if (loadingIndicator) {
              loadingIndicator.style.display = 'none';
            }
            isLoading = false;
        });
}